import withSplitting from 'components/hoc/withSplitting'
export default withSplitting(() => import('./AppDetailView'), {
  componentName: 'organisms|AppDetailView',
})
